// extracted by mini-css-extract-plugin
export var sm = "768";
export var md = "1024";
export var lg = "1280";
export var xl = "1600";
export var wrapper = "HeroSection-module--wrapper--H--f1";
export var contactsWrapper = "HeroSection-module--contactsWrapper--y+zY8";